module.exports = __webpack_public_path__ + "static/media/logo-horizontal.20074f75.svg";